var _Divider;
import clsx from 'clsx';
import * as React from 'react';
import { match } from 'ts-pattern';
import { colors } from '@ovpn-ui/styles';
import Divider from '../Divider';
import Text from '../Text';
import * as Styled from './Header.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const matchTitleTextVariant = level => match(level).with('h1', () => 'displayMd').otherwise(() => 'textLg');
const matchDescriptionTextVariant = level => match(level).with('h1', () => 'textMd').otherwise(() => 'textSm');
const matchAriaLevel = level => match(level).with('h2', () => 2).with('h3', () => 3).otherwise(() => 1);
const Header = /*#__PURE__*/React.forwardRef(function Header({
  level = 'h1',
  divider = false,
  title,
  description,
  className,
  ...props
}, ref) {
  return /*#__PURE__*/_jsxs(Styled.Header, {
    ref: ref,
    className: clsx('ovpn-header', className),
    ...props,
    children: [/*#__PURE__*/React.createElement(Text, {
      as: level,
      role: 'heading',
      weight: 'semiBold',
      variant: matchTitleTextVariant(level),
      color: colors.neutralTextTitle,
      className: 'ovpn-header-title',
      'aria-level': matchAriaLevel(level)
    }, title), description && /*#__PURE__*/_jsx(Text, {
      color: colors.neutralTextSubtitle,
      className: "ovpn-header-description",
      variant: matchDescriptionTextVariant(level),
      children: description
    }), divider && (_Divider || (_Divider = /*#__PURE__*/_jsx(Divider, {})))]
  });
});
export default Header;